import React from 'react';

import { ILink } from 'utils/types';
import { TextButton } from 'components/button/TextButton';
import { Fade } from 'components/animations/Fade';

import AlvotechBasket from 'components/assets/user-icons/Alvotech_basket.svg';
import AlvotechBiosimilar from 'components/assets/user-icons/Alvotech_biosimilar2.svg';
import AlvotechCosmetics from 'components/assets/user-icons/Alvotech_cosmetics.svg';
import AlvotechEmploeeys from 'components/assets/user-icons/Alvotech_emploeeys.svg';
import AlvotechGenericProjects from 'components/assets/user-icons/Alvotech_generic-projects.svg';
import AlvotechGreen from 'components/assets/user-icons/Alvotech_green.svg';
import AlvotechHandPill from 'components/assets/user-icons/Alvotech_hand-pill.svg';
import AlvotechKeyGrowth from 'components/assets/user-icons/Alvotech_key-growth copy.svg';
import AlvotechManufacturinCenters from 'components/assets/user-icons/Alvotech_manufacturin-centers.svg';
import AlvotechMap from 'components/assets/user-icons/Alvotech_map.svg';
import AlvotechMedical from 'components/assets/user-icons/Alvotech_medical.svg';
import AlvotechMicroscope from 'components/assets/user-icons/Alvotech_microscope.svg';
import AlvotechMolecule from 'components/assets/user-icons/Alvotech_molecule.svg';
import AlvotechNetwork from 'components/assets/user-icons/Alvotech_network.svg';
import AlvotechPipeline from 'components/assets/user-icons/Alvotech_pipeline2.svg';
import AlvotechPlayground from 'components/assets/user-icons/Alvotech_playground.svg';
import AlvotechAward from 'components/assets/user-icons/Alvotech_award.svg';
import AlvotechBiosGenerics from 'components/assets/user-icons/Alvotech_bios-generics.svg';
import AlvotechCapacity from 'components/assets/user-icons/Alvotech_capacity.svg';
import AlvotechCompany from 'components/assets/user-icons/Alvotech_company.svg';
import AlvotechDna from 'components/assets/user-icons/Alvotech_dna.svg';
import AlvotechInvestment from 'components/assets/user-icons/Alvotech_investment.svg';
import AlvotechManufacturing from 'components/assets/user-icons/Alvotech_manufacturing.svg';
import AlvotechPeople from 'components/assets/user-icons/Alvotech_people.svg';
import AlvotechPills from 'components/assets/user-icons/Alvotech_pills.svg';
import AlvotechProfessional from 'components/assets/user-icons/Alvotech_professional.svg';
import AlvotechSquareMeter from 'components/assets/user-icons/Alvotech_square-meter.svg';

import s from './ColumnSection.module.scss';

type Props = {
  index?: number;
  title?: string;
  text?: React.ReactNode;
  link?: ILink;
  label?: string;
  isVisible?: boolean;
  delay?: number;
  numbered?: boolean;
  icon?: string | null;
  color?: 'brand' | 'white' | 'dark' | string;
};

export const ColumnSectionItem = ({
  title,
  text,
  index,
  link,
  label,
  isVisible,
  delay,
  numbered,
  icon = '',
  color,
}: Props) => {
  const hasIcon = icon && icon.length > 0;
  // const iconName = hasIcon && (icon as string).replace(/^\w/, (c) => c.toUpperCase());
  // const TagName = `Alvotech${iconName}`;

  // console.log(TagName);

  const setIcon = () => {
    switch (icon && icon.toLowerCase().replace(/\s/g, '')) {
      case 'basket':
        return <AlvotechBasket />;
      case 'biosimilar':
        return <AlvotechBiosimilar />;
      case 'cosmetics':
        return <AlvotechCosmetics />;
      case 'emploeeys':
        return <AlvotechEmploeeys />;
      case 'genericprojects':
        return <AlvotechGenericProjects />;
      case 'green':
        return <AlvotechGreen />;
      case 'handpill':
        return <AlvotechHandPill />;
      case 'keygrowth':
        return <AlvotechKeyGrowth />;
      case 'manufacturincenters':
        return <AlvotechManufacturinCenters />;
      case 'map':
        return <AlvotechMap />;
      case 'medical':
        return <AlvotechMedical />;
      case 'microscope':
        return <AlvotechMicroscope />;
      case 'molecule':
        return <AlvotechMolecule />;
      case 'network':
        return <AlvotechNetwork />;
      case 'pipeline':
        return <AlvotechPipeline />;
      case 'playground':
        return <AlvotechPlayground />;
      case 'award':
        return <AlvotechAward />;
      case 'biosgenerics':
        return <AlvotechBiosGenerics />;
      case 'capacity':
        return <AlvotechCapacity />;
      case 'company':
        return <AlvotechCompany />;
      case 'dna':
        return <AlvotechDna />;
      case 'investment':
        return <AlvotechInvestment />;
      case 'manufacturing':
        return <AlvotechManufacturing />;
      case 'people':
        return <AlvotechPeople />;
      case 'pills':
        return <AlvotechPills />;
      case 'professional':
        return <AlvotechProfessional />;
      case 'squaremeter':
        return <AlvotechSquareMeter />;
    }
  };

  return (
    <Fade isVisible={isVisible} delay={delay}>
      <div className={s.item}>
        {(numbered || hasIcon) && (
          <div className={s.item__decor}>
            {hasIcon && setIcon()}
            {numbered && <div className={s.item__counter} />}
          </div>
        )}
        <div className={s.item__layout}>
          <div className={s.item__content}>
            {title && <h3 className={s.item__title}>{title}</h3>}
            {text && (
              <div className={s.item__row}>
                <div className={s.item__text}>
                  <div className={s.item__copy}>{text}</div>
                </div>
              </div>
            )}
          </div>
          {link && (
            <div className={s.item__link}>
              <TextButton {...link} color={color} staticColor>
                {label || 'Learn more'}
              </TextButton>
            </div>
          )}
        </div>
      </div>
    </Fade>
  );
};
